import { render, staticRenderFns } from "./DriversShiftsReportTemplate.vue?vue&type=template&id=5a5f5c52"
import script from "./DriversShiftsReportTemplate.vue?vue&type=script&lang=js"
export * from "./DriversShiftsReportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports